import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectDisposalIncompleteSprayEvents } from '../../../../selectors';

const selectDisposalFields = createDeepEqualSelector(
    selectDisposalIncompleteSprayEvents,
    (disposalIncompleteSprayEvents) =>
        disposalIncompleteSprayEvents.map(({ uuid }) => uuid)
);

export { selectDisposalFields };
